import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';

@Component({
  standalone: true,
  imports: [
    MatCardModule,
    MatRadioModule
  ],
  selector: 'equine-ui-nx-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrls: ['./payment-type.component.scss']
})
export class PaymentTypeComponent implements OnInit {

  @Output() checked = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    this.checked.emit('paypal');
  }

  onChecked(change: MatRadioChange) {
    this.checked.emit(change.value);
  }

}
